import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from "vue";
import { ClassnameType } from "@/ts/types/components";


const __default__ = {
  name: "BaseForm",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    classname: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass([_ctx.classname, "base-form"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})